import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { PDSService } from '../../../services/pds.service';
@Component({
  selector: 'app-ski-cover',
  standalone: true,
  imports: [FooterComponent, StaticSearchComponent, CommonHeaderComponent],
  templateUrl: './ski-cover.component.html',
  styleUrl: './ski-cover.component.scss',
})
export class SkiCoverComponent {
  partnerCode: string = '';
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public pdsService: PDSService,
  ) {
    this.titleService.setTitle(
      'Ski, Snowboarding & Winter Sports Travel Insurance | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content: `You can stay protected on the slopes with World2Cover travel insurance, with optional cover for skiing, snowboarding and winter sports plus 24/7 emergency assistance.`,
    });
    this.metaService.updateTag({
      property: 'og:title',
      content:
        'Ski, Snowboarding & Winter Sports Travel Insurance | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content: `You can stay protected on the slopes with World2Cover travel insurance, with optional cover for skiing, snowboarding and winter sports plus 24/7 emergency assistance.`,
    });
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
  }
}
